/**
 * @description 通用配置
 */
const setting = {
    // 标题
    title: '美致实验幼儿园',
    // 默认的接口地址
    baseURL: '/',
    //token存储位置localStorage sessionStorage cookie
    storage: 'localStorage',
}
module.exports = setting